export default __webpack_public_path__ + "magic-wand.png";